import React from 'react'

export interface CreateItem {
  id: string
  title: Record<string, string>      // Keyed by language code
  description: Record<string, string> // Keyed by language code
  icon: React.ReactNode
  href: string                        // Internal path or external URL
  external?: boolean                  // True when href leaves the console
  category: string                    // Free-form grouping label
}

export const createData: CreateItem[] = [
  {
    id: 'pipeline-studio-flow',
    title: {
      en: 'Pipeline Studio Flow',
      zh: 'Pipeline Studio Flow'
    },
    description: {
      en: 'Create a new data pipeline flow',
      zh: '創建新的數據管道流程'
    },
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    category: 'product',
    href: '/products/pipeline-studio/create'
  },
  // {
  //   id: 'data-source',
  //   title: {
  //     en: 'Data Source',
  //     zh: 'Data source'
  //   },
  //   description: {
  //     en: 'Add a new data source connection',
  //     zh: 'Add a data source connection'
  //   },
  //   icon: (
  //     <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
  //     </svg>
  //   ),
  //   category: 'data',
  //   href: '/data/source/create'
  // },
  // {
  //   id: 'data-destination',
  //   title: {
  //     en: 'Data Destination',
  //     zh: 'Data target'
  //   },
  //   description: {
  //     en: 'Add a new data destination connection',
  //     zh: 'Add a data target connection'
  //   },
  //   icon: (
  //     <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
  //     </svg>
  //   ),
  //   category: 'data',
  //   href: '/data/destination/create'
  // }
]
